"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopy = void 0;
var react_1 = require("react");
exports.deepCopy = function (inObject) {
    var value;
    var key;
    if (typeof inObject !== "object" ||
        inObject === null ||
        /** ReactNode 元素不 COPY，https://git.woa.com/tea-design/tea2/issues/514 */
        react_1.isValidElement(inObject)) {
        return inObject;
    }
    var outObject = Array.isArray(inObject) ? [] : {};
    // eslint-disable-next-line guard-for-in
    for (key in inObject) {
        value = inObject[key];
        outObject[key] = exports.deepCopy(value);
    }
    return outObject;
};
//# sourceMappingURL=deep-copy.js.map